let interceptor = require('rest/interceptor');

function delay(wait, promiseOrValue) {
    return Promise.resolve(promiseOrValue).then(function (value) {
        return new Promise(function (resolve) {
            setTimeout(function () {
                resolve(value);
            }, wait);
        });
    });
}


function showOverlay(show) {
    let overlay = document.getElementById('progeny-snr-overlay');
    let overlayGlass = document.getElementById('progeny-snr-overlay-glass');

    if (show) {
        overlay.style.visibility = "visible";
        overlayGlass.style.visibility = "visible";
    } else {
        overlay.style.visibility = "hidden";
        overlayGlass.style.visibility = "hidden";
    }
}

function showSessionError() {
    let message = document.getElementById('progeny-session-message');
    message.style.visibility = "visible";
    message.style.zIndex = "10001";
}

function showMessage() {
    let message = document.getElementById('progeny-snr-message');
    message.style.visibility = "visible";
    message.style.zIndex = "10001";
}

let restInterceptor = interceptor({
    init: function (config) {
        config.initial = config.initial || 100;
        config.multiplier = config.multiplier || 2;
        config.max = config.max || Infinity;
        return config;
    },
    response: function (response, config) {
        if (response.request.snr) {
            showOverlay(false);
        }
        return response;
    },
    error: function (response, config, meta) {
        let request = response.request;
        if (response.status.code === 0) {

            showOverlay(true);

            request.retry = request.retry || config.initial;
            request.snr = true;

            return delay(request.retry, request).then(function (request) {
                if (request.canceled) {
                    // cancel here in case client doesn't check canceled flag
                    return Promise.reject({request: request, error: 'precanceled'});
                }
                request.retry = Math.min(request.retry * config.multiplier, config.max);
                request.entity = request.entity ? JSON.parse(request.entity) : "";
                return meta.client(request);
            });
        } else if (response.status.code === 400) {
            showSessionError();
        } else if (request.snr) {
            showMessage();
        } else {
            return response;
        }
    }
});

export default restInterceptor;